import { ISecTwpRngReposList } from "views/mpci/lands/viewmodels/iSecTwpRngReposList"
import * as AllSagas from './sagas';
export { default as reducer } from './reducer';
export const Sagas = Object.values(AllSagas);

export interface SectionTownshipState {
    sectionTownShips: Record<string, ISecTwpRngReposList[]>;
    errorCode: string;
    isLoading: boolean;
}